(() => {
  const configuration = document.getElementById('tmx-badge-schedules');
  let schedules = [];

  try {
    schedules = JSON.parse(configuration?.textContent || '[]');
  } catch (error) {
    console.warn('[TMX badges] No se pudo leer la configuración.', error);
  }

  if (!Array.isArray(schedules)) schedules = [];

  const peruvianOffset = '-05:00';
  const datePattern = /^\d{4}-\d{2}-\d{2}$/;
  const timePattern = /^\d{2}:\d{2}$/;
  let timerId;
  let renderQueued = false;

  const parseBoundary = (date, time) => {
    if (!date) return null;
    if (!datePattern.test(date)) return Number.NaN;
    const normalizedTime = time || '00:00';
    if (!timePattern.test(normalizedTime)) return Number.NaN;
    return Date.parse(`${date}T${normalizedTime}:00${peruvianOffset}`);
  };

  const scheduleByHandle = new Map(
    schedules
      .filter((schedule) => schedule && typeof schedule.badge_handle === 'string' && schedule.badge_handle)
      .map((schedule) => [schedule.badge_handle.trim(), schedule])
  );

  const normalize = (value) => String(value || '').trim();

  const productMatches = (schedule, productHandle, productSkus) => {
    const targetHandles = Array.isArray(schedule.product_handles)
      ? schedule.product_handles.map(normalize).filter(Boolean)
      : [];
    const targetSkus = Array.isArray(schedule.product_skus)
      ? schedule.product_skus.map(normalize).filter(Boolean)
      : [];
    const currentSkus = new Set(productSkus.split(',').map(normalize).filter(Boolean));

    if (targetHandles.length === 0 && targetSkus.length === 0) return false;
    if (targetHandles.includes(normalize(productHandle))) return true;
    return targetSkus.some((sku) => currentSkus.has(sku));
  };

  const activeFor = (candidate, now) => {
    const handle = normalize(candidate.dataset.tmxBadgeHandle);
    const isCampaign = candidate.dataset.tmxBadgeCampaign === 'true';
    const schedule = scheduleByHandle.get(handle);

    if (!schedule) return !isCampaign;
    if (schedule.enabled !== true) return !isCampaign;

    if (
      isCampaign &&
      !productMatches(
        schedule,
        candidate.dataset.tmxProductHandle,
        candidate.dataset.tmxProductSkus || ''
      )
    ) {
      return false;
    }

    const start = parseBoundary(schedule.start_date, schedule.start_time);
    const end = parseBoundary(schedule.end_date, schedule.end_time);

    if (!start && !end) return !isCampaign;
    if ((schedule.start_date && !Number.isFinite(start)) || (schedule.end_date && !Number.isFinite(end))) {
      return !isCampaign;
    }

    return (!start || now >= start) && (!end || now < end);
  };

  const isVisible = (element) => !element.hidden && element.style.display !== 'none';

  const setVisibility = (element, shouldShow) => {
    const hidden = !shouldShow;
    if (element.hidden !== hidden) element.hidden = hidden;
    if (element.getAttribute('aria-hidden') !== String(hidden)) {
      element.setAttribute('aria-hidden', String(hidden));
    }
    const display = shouldShow ? '' : 'none';
    if (element.style.display !== display) element.style.display = display;
  };

  const visibleSystemCount = (container) => {
    const systems = Array.from(container.querySelectorAll(':scope > [data-tmx-badge-system]'))
      .filter(isVisible);

    if (systems.length < 2) return systems.length;

    const preferred =
      systems.find((badge) => badge.dataset.tmxBadgeSystem === 'discount') ||
      systems.find((badge) => badge.dataset.tmxBadgeSystem === 'sold_out') ||
      systems[0];

    systems.forEach((badge) => setVisibility(badge, badge === preferred));
    return 1;
  };

  const update = () => {
    renderQueued = false;
    const now = Date.now();
    const containers = new Set();

    document.querySelectorAll('[data-tmx-badge-candidate]').forEach((candidate) => {
      if (candidate.parentElement) containers.add(candidate.parentElement);
    });

    containers.forEach((container) => {
      const candidates = Array.from(container.querySelectorAll(':scope > [data-tmx-badge-candidate]'));
      const customLimit = Math.max(0, 2 - visibleSystemCount(container));

      const activeCampaign = candidates.find(
        (candidate) =>
          candidate.dataset.tmxBadgeCampaign === 'true' && activeFor(candidate, now)
      );

      if (activeCampaign) {
        const allowed = customLimit > 0 ? [activeCampaign] : [];
        if (customLimit > 1) {
          const ordinaryBadge = candidates.find(
            (candidate) =>
              candidate !== activeCampaign &&
              candidate.dataset.tmxBadgeCampaign !== 'true' &&
              activeFor(candidate, now)
          );
          if (ordinaryBadge) allowed.push(ordinaryBadge);
        }
        candidates.forEach((candidate) => setVisibility(candidate, allowed.includes(candidate)));
        return;
      }

      let visibleCustom = 0;
      candidates.forEach((candidate) => {
        const shouldShow = activeFor(candidate, now) && visibleCustom < customLimit;
        setVisibility(candidate, shouldShow);
        if (shouldShow) visibleCustom += 1;
      });
    });

    scheduleNextUpdate(now);
  };

  const scheduleNextUpdate = (now) => {
    window.clearTimeout(timerId);
    const boundaries = [];

    schedules.forEach((schedule) => {
      if (!schedule || schedule.enabled !== true) return;
      const start = parseBoundary(schedule.start_date, schedule.start_time);
      const end = parseBoundary(schedule.end_date, schedule.end_time);
      if (Number.isFinite(start) && start > now) boundaries.push(start);
      if (Number.isFinite(end) && end > now) boundaries.push(end);
    });

    const nextBoundary = boundaries.length ? Math.min(...boundaries) : now + 60000;
    timerId = window.setTimeout(update, Math.max(250, Math.min(nextBoundary - now + 50, 60000)));
  };

  const queueUpdate = () => {
    if (renderQueued) return;
    renderQueued = true;
    window.requestAnimationFrame(update);
  };

  window.tmxBadgeSchedulerUpdate = queueUpdate;
  update();

  new MutationObserver(queueUpdate).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['hidden', 'style'],
    childList: true,
    subtree: true
  });
})();
